
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.935 23.844zM14.175 23.803l-.144.025.144-.025zM13.366 23.922zM13.596 23.894zM14.502 23.738l-.127.027c.042-.01.085-.018.127-.027zM15.312 23.537l-.102.028.102-.028zM15.067 23.604l-.111.029.111-.03zM14.746 23.684l-.118.026.118-.026zM13.009 23.957z","fill":"#000"}}),_c('path',{attrs:{"d":"M24 12c0-6.626-5.374-12-12-12S0 5.374 0 12s5.374 12 12 12l.21-.003v-9.341H9.634V11.65h2.578v-2.21c0-2.565 1.565-3.96 3.853-3.96 1.095 0 2.037.081 2.311.117v2.68h-1.577c-1.245 0-1.486.592-1.486 1.46v1.913h2.976l-.388 3.005h-2.588v8.88C20.328 22.098 24 17.477 24 12z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.793 23.973zM12.41 23.992z","fill":"#000"}})])
          )
        }
      }
    